import { render } from "./SupplierProfile.vue?vue&type=template&id=31123e0e&scoped=true"
import script from "./SupplierProfile.vue?vue&type=script&lang=js"
export * from "./SupplierProfile.vue?vue&type=script&lang=js"

import "./SupplierProfile.vue?vue&type=style&index=0&id=31123e0e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31123e0e"]])

export default __exports__